import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { SharedModule } from "../shared/shared.module";
import { RelatorioPagamentoDecendialComponent } from "./pages/relatorio-pagamento-decendial/relatorio-pagamento-decendial.component";

@NgModule({
  declarations: [RelatorioPagamentoDecendialComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
  ],

  schemas: [NO_ERRORS_SCHEMA],
})
export class SpgModule {}
